export default "__VITE_ASSET__664808db__"